import ScrollToTopOnMount from "../../components/ScrollToTopOnMount/ScrollToTopOnMount";
import HowItWorks from "../../layouts/HowItWorks/HowItWorks";

const HowitworksPage = () => {
    return(
        <>
            <ScrollToTopOnMount />
            <HowItWorks />
        </>
        
    )
}

export default HowitworksPage;